import { useQuery } from '@tanstack/react-query';
import { Flame } from 'lucide-react';
import { api } from '../lib/api';
import { useWorkspace } from '../lib/workspace';

// ─────────────────────────────────────────────────────────────────────────────
// MatchNightBanner
// A narrow ember strip that appears at the top of the main content area
// whenever there's at least one IN_PROGRESS match in the active competition.
// Creates urgency without being obnoxious. Auto-hides when the forge cools.
// ─────────────────────────────────────────────────────────────────────────────

export function MatchNightBanner() {
  const { activeCompId } = useWorkspace();
  const { data: matches } = useQuery({
    queryKey: ['matches', activeCompId],
    queryFn: () => api.matches(activeCompId!),
    enabled: !!activeCompId,
    refetchInterval: 60_000,
    retry: false,
  });

  const liveCount = (matches ?? []).filter(m => m.status === 'IN_PROGRESS').length;
  if (liveCount === 0) return null;

  return (
    <div className="relative overflow-hidden border-b border-forge-500/40">
      <div className="pointer-events-none absolute inset-0 animate-ember-pulse bg-gradient-to-r from-transparent via-forge-600/20 to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-forge-500/80 to-transparent" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-forge-500/60 to-transparent" />

      <div className="relative mx-auto flex max-w-7xl items-center justify-center gap-3 px-4 py-2.5">
        <Flame className="h-4 w-4 shrink-0 animate-pulse text-forge-400" strokeWidth={2.5} />
        <p className="font-display text-[11px] font-black uppercase tracking-[0.22em] text-forge-300">
          Forge is lit ·{' '}
          <span className="text-white">{liveCount}</span> match
          {liveCount !== 1 ? 'es' : ''} live now
        </p>
        <Flame className="h-4 w-4 shrink-0 animate-pulse text-forge-400" strokeWidth={2.5} />
      </div>
    </div>
  );
}
